import {
  actionTypes,
  CompanyData,
  UserData,
  SetCompanyData,
  SetCompanyDataError,
  SetCompanyDataSucceeded,
  ResetCompanyData,
} from './types'

export const setCompanyData = (): SetCompanyData => {
  return {
    type: actionTypes.SET_COMPANY_DATA,
    payload: null,
  }
}

export const setCompanyDataSucceeded = (value: {
  companyData: CompanyData | null
  userData: UserData | null
  isLogged: boolean | null
}): SetCompanyDataSucceeded => {
  return {
    type: actionTypes.SET_COMPANY_DATA_SUCCEEDED,
    payload: value,
  }
}

export const setCompanyDataError = (): SetCompanyDataError => {
  return {
    type: actionTypes.SET_COMPANY_DATA_ERROR,
    payload: null,
  }
}

export const setCompanyDataReset = (): ResetCompanyData => {
  return {
    type: actionTypes.RESET_COMPANY_DATA,
    payload: null,
  }
}
